const SE = {
  company: [
    "aktiebolag (Ab)",
    "publikt aktiebolag (AB publ)",
    "ideell förening"
  ],
  legalArrangement: [
    "kommanditbolag (KB)",
    "ekonomisk förening (Ek. för.)",
    "kooperativ hyresrättsförening (KHF)"
  ],
  soleProprietorship: [
    "enskild firma"
  ]
};
export {
  SE as default
};
